import React from "react";

const CloseIconRaw = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.39994 13.6537L0.346191 12.5999L5.94619 6.99994L0.346191 1.39994L1.39994 0.346191L6.99994 5.94619L12.5999 0.346191L13.6537 1.39994L8.05369 6.99994L13.6537 12.5999L12.5999 13.6537L6.99994 8.05369L1.39994 13.6537Z"
        fill="#8692A8"
      />
    </svg>
  );
};

export default CloseIconRaw;
